import { AnyAction } from "redux";
import { call, put, select, takeLeading } from "redux-saga/effects";
import { SET_LOADING, SET_SERVER_MESSAGE, SOLVE_LEASE_QUOTE, SolveLeaseQuoteAction, solveLeaseQuoteSuccess } from "./types";
import { runRulesAfterServerSave } from "./actions";
import { updateLeaseQuoteCalcErrorsSuccess } from "../Notifications/actions";
import { requestLeaseQuoteSolve } from "../../Data/LeaseQuoteData";
import { ApplicationLeaseCalculationResult } from "../../Interfaces/Application/ApplicationLeaseCalculationResult";
import { AppState } from "../rootReducer";

const selectOpenApplicationId = (state: AppState) => state.applications.editingApp?.id;

export function* solveLeaseQuoteSaga(action: SolveLeaseQuoteAction) {
  yield put({ type: SET_LOADING, payload: true });
  try {
    const result: ApplicationLeaseCalculationResult = yield call(
      requestLeaseQuoteSolve, action.payload.application, action.payload.mode, action.payload.newVehicle?.id);
    yield put(solveLeaseQuoteSuccess(result, action.payload.newVehicle));
    const openApplicationId: string | undefined = yield select(selectOpenApplicationId);
    if (result.applicationLeaseQuote && openApplicationId === result.applicationId) {
      // The Solve saved new figures; lease rule errors gate status changes.
      yield put(runRulesAfterServerSave(action.payload.businessRulesEngine) as unknown as AnyAction);
    }
    if (result.errors.length > 0) {
      yield put(updateLeaseQuoteCalcErrorsSuccess(result.errors));
    }
  } catch (error: any) {
    yield put({ type: SET_SERVER_MESSAGE, payload: { message: error?.message ?? String(error), isError: true } });
  }
  yield put({ type: SET_LOADING, payload: false });
}

// takeLeading: a second Solve while one runs is ignored; the running one saves on the server either way.
export function* watchSolveLeaseQuoteSaga() {
  yield takeLeading(SOLVE_LEASE_QUOTE, solveLeaseQuoteSaga);
}
